import React from "react";
import {useFormik} from "formik";
import * as yup from "yup";
import startOfToday from "date-fns/startOfToday";

import {isValidDateObject} from "../../../services/date/validators";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";


const validationSchema = yup.object().shape({
    arrival: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .min(startOfToday(), 'Deve essere maggiore o uguale alla data di oggi')
        .required('Campo obbligatorio'),
    departure: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .min(yup.ref('arrival'), 'Deve essere maggiore rispetto alla data di arrivo')
        .required('Campo obbligatorio'),
    people: yup
        .number()
        .positive('Deve essere un numero positivo')
        .integer('Deve essere un numero intero')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
});


const SearchForm = function ({onSubmit}) {

    const formik = useFormik({
        initialValues: {
            arrival: null,
            departure: null,
            people: 2,
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit
    });

    return <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
            <ArrivalDatePicker formik={formik}/>
        </Grid>

        <Grid item xs={12} md={4}>
            <DepartureDatePicker formik={formik}/>
        </Grid>

        <Grid item xs={12} md={4}>
            <PeopleSelect formik={formik}/>
        </Grid>

        <Grid item xs={12} textAlign='center'>
            <Button size="small"
                    variant="contained"
                    color="primary"
                    startIcon={<SearchIcon/>}
                    sx={{mt: 1, mb: 3}}
                    onClick={formik.handleSubmit}>
                Cerca
            </Button>
        </Grid>
    </Grid>
}

const ArrivalDatePicker = function ({formik}) {
    return <DatePicker
        value={formik.values.arrival}
        onChange={date => formik.setFieldValue("arrival", date)}
        disablePast
        label="Data di arrivo"
        closeOnSelect
        disableHighlightToday={true}
        showDaysOutsideCurrentMonth={true}
        slotProps={{
            textField: {
                fullWidth: true,
                required: true,
                error: Boolean(formik.touched.arrival) && Boolean(formik.errors.arrival),
                helperText: formik.touched.arrival && formik.errors.arrival,
                sx: {mb: 2}
            },
        }}/>
}

const DepartureDatePicker = function ({formik}) {
    return <DatePicker
        value={formik.values.departure}
        onChange={date => formik.setFieldValue("departure", date)}
        disablePast
        minDate={formik.values.arrival}
        defaultCalendarMonth={isValidDateObject(formik.values.arrival) ? formik.values.arrival : undefined}
        label="Data di partenza"
        closeOnSelect
        disableHighlightToday={true}
        showDaysOutsideCurrentMonth={true}
        slotProps={{
            textField: {
                fullWidth: true,
                required: true,
                error: Boolean(formik.touched.departure) && Boolean(formik.errors.departure),
                helperText: formik.touched.departure && formik.errors.departure,
                sx: {mb: 2}
            }
        }}/>
}

const PeopleSelect = function ({formik}) {

    const peopleOptions = [...new Array(20)].map((_, i) => (
        {
            value: i + 1,
            label: `${i + 1} ${'person'}${i === 0 ? 'a' : 'e'}`
        }));

    return <TextField select
                      label="Numero persone (adulti e bambini)"
                      fullWidth
                      name="people"
                      required
                      value={formik.values.people}
                      onChange={formik.handleChange}
                      error={formik.touched.people && Boolean(formik.errors.people)}
                      helperText={formik.touched.people && formik.errors.people}
                      SelectProps={{'MenuProps': {"sx": {maxHeight: '300px'}}}}>
        {
            peopleOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))
        }
    </TextField>
}

export default SearchForm;